module.exports = __webpack_public_path__ + "img/swingVariabilityText7.b5196b6e.png";